import { render, staticRenderFns } from "./customContent.vue?vue&type=template&id=1198e32d&scoped=true"
import script from "./customContent.vue?vue&type=script&lang=js"
export * from "./customContent.vue?vue&type=script&lang=js"
import style0 from "./customContent.vue?vue&type=style&index=0&id=1198e32d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1198e32d",
  null
  
)

export default component.exports